// UI twin of create-agent wire fields. Server authorization remains authoritative.
import { z } from "zod";
import { AUTONOMY_LEVELS } from "./core/autonomy.js";
export const agentCreateInput = z
  .object({
    slug: z.string().min(1).max(60),
    name: z.string().min(1).max(100),
    soul: z.string().max(50000).optional(),
    provider: z.string(),
    model: z.string().optional(),
    description: z.string().max(500).optional(),
    avatar: z.string().optional(),
    role: z.string().max(100).optional(),
    llmAuthMode: z.enum(["cli", "api-key", "managed", "oauth", "wellknown"]).optional(),
    behaviorMode: z.enum(["responsive", "proactive"]).optional(),
    homeDaemonId: z.string().nullable().optional(),
    autonomyLevel: z.enum(AUTONOMY_LEVELS).nullable().optional(),
    monthlySpendCap: z.number().int().nonnegative().nullable().optional(),
    platformPermissions: z
      .array(
        z.enum([
          "send_message",
          "create_task",
          "create_task_only",
          "manage_channels",
          "spawn_agents",
          "manage_self",
          "manage_memory",
          "prompt_sessions",
          "read_messages",
          "react",
          "search",
        ]),
      )
      .optional(),
    bypassPermissions: z.boolean().optional(),
    isDefault: z.boolean().optional(),
  })
  .passthrough();
